import type { RS1State } from "./useRS1Audio";

type Preset = Omit<RS1State, "volume">;

export const PRESETS: Record<string, Preset> = {
  init: {
    waveform1: "sawtooth",
    waveform2: "sawtooth",
    mix: 0.5,
    detune: 5,
    cutoff: 0.8,
    resonance: 0,
    filterEnvAmt: 0.5,
    attack: 0.01,
    decay: 0.3,
    sustain: 0.7,
    release: 0.5,
    fAttack: 0.01,
    fDecay: 0.8,
    fSustain: 0.25,
    fRelease: 0.3,
    lfoWaveform: "sine",
    lfoRate: 0.5,
    lfoDepth: 0,
    lfoDest: "filter",
    drive: 0,
    delayTime: 0.5,
    delayMix: 0,
    reverbSize: 0.5,
    reverbMix: 0,
  },
  warmPad: {
    waveform1: "sawtooth",
    waveform2: "sawtooth",
    mix: 0.5,
    detune: 12,
    cutoff: 0.4,
    resonance: 0.2,
    filterEnvAmt: 0.3,
    attack: 0.4,
    decay: 0.5,
    sustain: 0.8,
    release: 1.0,
    fAttack: 0.3,
    fDecay: 0.6,
    fSustain: 0.4,
    fRelease: 0.8,
    lfoWaveform: "triangle",
    lfoRate: 0.15,
    lfoDepth: 0.2,
    lfoDest: "filter",
    drive: 0,
    delayTime: 0.4,
    delayMix: 0.2,
    reverbSize: 0.7,
    reverbMix: 0.4,
  },
  bass: {
    waveform1: "square",
    waveform2: "sawtooth",
    mix: 0.3,
    detune: 0,
    cutoff: 0.25,
    resonance: 0.4,
    filterEnvAmt: 0.6,
    attack: 0.01,
    decay: 0.2,
    sustain: 0.4,
    release: 0.2,
    fAttack: 0.01,
    fDecay: 0.3,
    fSustain: 0.2,
    fRelease: 0.2,
    lfoWaveform: "sine",
    lfoRate: 0.5,
    lfoDepth: 0,
    lfoDest: "filter",
    drive: 0.3,
    delayTime: 0.5,
    delayMix: 0,
    reverbSize: 0.3,
    reverbMix: 0.1,
  },
  lead: {
    waveform1: "sawtooth",
    waveform2: "square",
    mix: 0.4,
    detune: 7,
    cutoff: 0.6,
    resonance: 0.3,
    filterEnvAmt: 0.5,
    attack: 0.01,
    decay: 0.1,
    sustain: 0.8,
    release: 0.3,
    fAttack: 0.01,
    fDecay: 0.2,
    fSustain: 0.5,
    fRelease: 0.2,
    lfoWaveform: "sine",
    lfoRate: 0.3,
    lfoDepth: 0.1,
    lfoDest: "pitch",
    drive: 0.15,
    delayTime: 0.35,
    delayMix: 0.25,
    reverbSize: 0.4,
    reverbMix: 0.2,
  },
  keys: {
    waveform1: "sine",
    waveform2: "triangle",
    mix: 0.6,
    detune: 3,
    cutoff: 0.7,
    resonance: 0.1,
    filterEnvAmt: 0.4,
    attack: 0.01,
    decay: 0.4,
    sustain: 0.3,
    release: 0.4,
    fAttack: 0.01,
    fDecay: 0.5,
    fSustain: 0.2,
    fRelease: 0.3,
    lfoWaveform: "sine",
    lfoRate: 0.25,
    lfoDepth: 0.05,
    lfoDest: "amp",
    drive: 0,
    delayTime: 0.3,
    delayMix: 0.15,
    reverbSize: 0.5,
    reverbMix: 0.25,
  },
  ambient: {
    waveform1: "sine",
    waveform2: "triangle",
    mix: 0.5,
    detune: 8,
    cutoff: 0.5,
    resonance: 0.15,
    filterEnvAmt: 0.2,
    attack: 0.8,
    decay: 0.5,
    sustain: 0.9,
    release: 2.0,
    fAttack: 0.5,
    fDecay: 0.8,
    fSustain: 0.6,
    fRelease: 1.5,
    lfoWaveform: "sine",
    lfoRate: 0.1,
    lfoDepth: 0.3,
    lfoDest: "filter",
    drive: 0,
    delayTime: 0.6,
    delayMix: 0.4,
    reverbSize: 0.9,
    reverbMix: 0.6,
  },
};

export const PRESET_NAMES: Record<string, string> = {
  init: "Init",
  warmPad: "Warm Pad",
  bass: "Bass",
  lead: "Lead",
  keys: "Keys",
  ambient: "Ambient",
};
